"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ok = exports.object = exports.defined = void 0;
var errors_1 = require("./errors");
exports.defined = function (target, message) {
    if (target === undefined) {
        throw new errors_1.AssertionError(message);
    }
};
exports.object = function (target, message) {
    if (target !== undefined &&
        (typeof target !== 'object' || Array.isArray(target) || target === null)) {
        throw new errors_1.AssertionError(message);
    }
};
exports.ok = function (target, message) {
    if (!target) {
        throw new errors_1.AssertionError(message);
    }
};
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/web-bi-logger/dist/src/lib/assert.js
// module id = 204
// module chunks = 0 1